// Initialize the landing page
initLandingPage();

// Initialize Gifty widget
initGiftyWidget();

/**
 * Initialize the landing page background based on configuration
 */
function initLandingPage() {
    const page = document.querySelector('#landing-page');
    let config = {};

    // Get config from data attribute
    if (page && page.dataset.config) {
        try {
            config = JSON.parse(page.dataset.config);
        } catch (e) {
            console.error('Error parsing landing page config:', e);
            return;
        }
    }

    if (!page || !config.background_type) return;

    switch (config.background_type) {
        case 'color':
            if (config.background_value) {
                page.style.backgroundColor = config.background_value;
            }
            break;

        case 'image':
            if (config.background_value && config.background_value_url) {
                page.style.backgroundImage = `url('${config.background_value_url}')`;
            }
            break;

        case 'pattern':
            if (config.background_value && config.background_value.svg) {
                // Sanitize SVG URL before using
                const sanitizedSvg = config.background_value.svg.replace(/[<>"']/g, '');
                page.style.backgroundImage = `url('${sanitizedSvg}')`;
            }
            break;
    }
}

/**
 * Initialize the Gifty widget
 */
function initGiftyWidget() {
    const giftyElement = document.querySelector('#gifty');
    let config = {};

    // Get config from data attribute
    if (giftyElement && giftyElement.dataset.giftyConfig) {
        try {
            config = JSON.parse(giftyElement.dataset.giftyConfig);
        } catch (e) {
            console.error('Error parsing Gifty config:', e);
            return;
        }
    }

    // Check if Gifty configuration exists
    if (!config || !config.key) return;

    // Set the global Gifty object that the widget expects
    window.Gifty = config;

    // Load the Gifty widget script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://static.gifty.nl/js/widget.js';

    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
    } else {
        document.head.appendChild(script);
    }
}
